/* eslint-disable no-param-reassign */
import qs from 'qs'
import { platform } from '@/utils/platform'
import { getEnvBaseUrl } from '@/utils'
import { LDBridge } from '@/utils/handleBrdge'
// #ifdef H5
// #endif
// import { encrypt, decrypt } from '@LD/land-ui'
import { encrypt, decrypt } from '@/utils/serviceSignature'
// #ifdef MP-WEIXIN
import { getHeaders as getFingerprintHeaders } from '@/utils/fingerprint'
// #endif

export type CustomRequestOptions = UniApp.RequestOptions & {
  query?: Record<string, any>
  /** 出错时是否隐藏错误提示 */
  hideErrorToast?: boolean
} & IUniUploadFileOptions // 添加uni.uploadFile参数类型

// 请求基准地址
const baseUrl = getEnvBaseUrl()
const getNonce = () => {
  let nonceStr = ''
  for (let i = 0; i < 32; i++) {
    nonceStr += Math.floor(Math.random() * 36).toString(36)
  }
  return nonceStr
}
/**
 * 确保对象键的顺序一致，用于签名和请求数据
 * @param obj 需要排序的对象
 * @returns 按字母顺序排序的新对象
 */
const sortObjectKeys = (obj: Record<string, any>): Record<string, any> => {
  // 防御性编程：确保 obj 是有效的对象
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
    return {};
  }
  
  const sortedKeys = Object.keys(obj).sort();
  const sortedObj: Record<string, any> = {};
  sortedKeys.forEach(key => {
    sortedObj[key] = obj[key];
  });
  return sortedObj;
}

export async function prepareRequestAuth(tokenKey: 'token' | 'tokenHK') {
  const cachedToken = uni.getStorageSync(tokenKey)
  if (cachedToken)
    return cachedToken

  try {
    const userInfo = await LDBridge.userInfo({})
    const bridgeToken = userInfo?.[tokenKey]
    if (bridgeToken) {
      uni.setStorageSync(tokenKey, bridgeToken)
      return bridgeToken
    }
  }
  catch (error) {
    console.warn(`原生橋接取得 ${tokenKey} 失敗:`, error)
  }

  return ''
}

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: CustomRequestOptions) {
    // console.log(options, 'options')
    
    // 安全处理 options.data，确保它是对象类型
    const safeData = (() => {
      if (!options.data || typeof options.data === 'string' || ArrayBuffer.isView(options.data)) {
        return {}
      }
      return options.data as Record<string, any>
    })()
    const nonce = getNonce()
    const timestamp = Date.now()
    let  signature = ''
    if (options.method == 'POST') {
      signature = `${options.method}\n${options.url}\n${timestamp}\n${nonce}\n${JSON.stringify(sortObjectKeys(safeData))}\n`
    } else {
      signature = `${options.method}\n${options.url}\n${timestamp}\n${nonce}\n`
    }
    // 接口请求支持通过 query 参数配置 queryString
    if (options.query) {
      const queryStr = qs.stringify(options.query)
      // console.log(queryStr, 'queryStr')
      if (options.url.includes('?')) {
        options.url += `&${queryStr}`
      } else {
        options.url += `?${queryStr}`
      }
    }
    options.data = sortObjectKeys(safeData)
    // console.log(options, 'options')
    // 非 http 开头需拼接地址
    if (!options.url.startsWith('http')) {
      // #ifdef H5
      // console.log(__VITE_APP_PROXY__)
      if (JSON.parse(__VITE_APP_PROXY__)) {
        // 自动拼接代理前缀
        options.url = import.meta.env.VITE_APP_PROXY_PREFIX + options.url
      } else {
        options.url = baseUrl + options.url
      }
      // #endif
      // 非H5正常拼接
      // #ifndef H5
      options.url = baseUrl + options.url
      // #endif
      // TIPS: 如果需要对接多个后端服务，也可以在这里处理，拼接成所需要的地址
    }
    // 1. 请求超时
    options.timeout ??= 10000 // 10s
    // 2. （可选）添加小程序端请求头标识
    options.header = {
      platform, // 可选，与 uniapp 定义的平台一致，告诉后台来源
      ...options.header,
    }
    // console.log(signature, '<<<<<<<<<<<<<<<<<<<<<<<<<<<signature')
    // 3. 添加 token 请求头标识
    const token = uni.getStorageSync('token')
    if (token) {
      options.header.nxCloudToken = token
      options.header.EcomAuthorization = `Bearer ${token}`
    }
    // options.header['XChannel'] = 'QD33710020'
    options.header['apiSignature'] = encrypt(signature, 'lingdi202506web3', 'lingdi202506web3')
    options.header['timestamp'] = timestamp
    options.header['nonce'] = nonce
    options.header['Accept-Language'] = 'zh-HK'

    // 4. 添加推广指纹码请求头（仅微信小程序环境）
    // #ifdef MP-WEIXIN
    // 当指纹启用时，将 promotionFingerprintCode 和 promotionTraceId 添加到请求头
    // Requirements: 7.1, 7.2, 7.3
    const fingerprintHeaders = getFingerprintHeaders()
    if (fingerprintHeaders) {
      options.header = {
        ...options.header,
        ...fingerprintHeaders,
      }
    }
    // #endif
    // console.log(options.header, '<<<<<<<<<<<<<<<<<<<<<<<<<<<options.header')
  },
}

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor)
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor)
  },
}
